var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 54.255,
    viewBox: "0 0 23 54.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "key",
    transform: "translate(23) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M18.641,5.7S.842,5.629.136,6.337c.409.017.953.058,1.56.115A.719.719,0,0,1,1.68,7.886c-.556.042-1.125.074-1.677.09-.318,1.124,28.784.346,28.784.346s1.357.2,1.327-1.069-.324-1.432-1.391-1.434l-2.285.008s-.311.026-.328-.781.139-4.633.139-4.633A.478.478,0,0,0,25.832.1L24.4.032a.439.439,0,0,0-.368.444c-.019.4-.07,2.532-.07,2.532v-.06a.367.367,0,0,1-.306.41s-1.094,0-1.755.044-.616-.417-.616-.417V.452A.438.438,0,0,0,20.924,0L19.485.036a.481.481,0,0,0-.424.3s.067,3.827.029,4.635-.548.724-.548.724Z",
    transform: "translate(24.142 4.592)",
    fill: "#ecc295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M1.746,2.354l.207-.524s-.368-.185-.606.516a1.827,1.827,0,0,0,.573,1.862,7.953,7.953,0,0,0,2.8,1.669c.74.04,1.391,0,1.492-.822,0,0-.2-.092-.373.2S4.7,4.614,4.8,4.116A1.571,1.571,0,0,1,7,3.485c.932.606,1.82,2.211.3,3.12s-4.3.235-5.762-1.322S-.328,1.984.259.733,2.576.017,3.075.967s.318,1.652-.113,1.966S1.746,2.354,1.746,2.354Z",
    transform: "translate(18.646 3.911)",
    fill: "#ecc295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M3.488,9.15s-.619.973-1.823-.811S1.622,4.4,1.722,4.21A3.533,3.533,0,0,1,3.911,2.5c1.449-.375,4.244-.781,5.748.407s2.375,3.215,2.025,4.6-1.023.655-1.023.655,1.136-.417-.2-1.317S8.846,8.2,9.132,8.648s1.053,1.439,1.956.932a3.452,3.452,0,0,0,1.35-4.494A9.191,9.191,0,0,0,8.386.506,5.9,5.9,0,0,0,.844,2.938c-2.515,4.124,1.314,7.421,2.171,7.592s2.205.328,2.069-1.112a1.609,1.609,0,0,0-1.72-1.555s-.809.164-.25,1.154A.323.323,0,0,0,3.488,9.15Z",
    transform: "translate(6.109 0)",
    fill: "#ecc295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M5.1,2.285l-.09-.545s.295-.128.387.594a2.086,2.086,0,0,1-.649,1.742c-.381.318-1.723,1.3-2.278,1.242S1.437,5.116,1.463,4.3c0,0,.159-.063.253.248s.916-.466.908-.973-.793-1.4-1.557-.937a2.033,2.033,0,0,0-.6,3.023c1.019,1.112,3.166.851,4.437-.47A4.936,4.936,0,0,0,6.4.9C6.117-.416,4.773-.127,4.283.739a1.811,1.811,0,0,0-.154,1.947C4.411,3.056,5.1,2.285,5.1,2.285Z",
    transform: "translate(0.077 5.202)",
    fill: "#ecc295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M1.754,4.51l.193.533s-.373.168-.591-.541a1.811,1.811,0,0,1,.623-1.838A7.876,7.876,0,0,1,4.82,1.106c.74-.014,1.391.058,1.468.882,0,0-.2.085-.367-.213s-1.147.594-1.068,1.094a1.585,1.585,0,0,0,2.183.72c.948-.569,1.88-2.134.384-3.105S3.127.067,1.625,1.569s-1.947,3.22-1.4,4.5,2.294.811,2.82-.118.364-1.638-.058-1.97S1.754,4.51,1.754,4.51Z",
    transform: "translate(18.637 12.567)",
    fill: "#ecc295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M3.582,1.476s-.591-1-1.844.734-.152,3.935-.057,4.13a3.6,3.6,0,0,0,2.14,1.808c1.438.435,4.219.955,5.757-.171s2.461-3.116,2.15-4.512-1.005-.7-1.005-.7,1.125.467-.232,1.308S8.911,2.655,9.21,2.217,10.3.827,11.191,1.365a3.482,3.482,0,0,1,1.224,4.547,9.046,9.046,0,0,1-4.172,4.413A5.968,5.968,0,0,1,.767,7.572,5.313,5.313,0,0,1,3.146.073c.859-.136,2.215-.238,2.039,1.2A1.581,1.581,0,0,1,3.421,2.756s-.8-.2-.218-1.162a.318.318,0,0,1,.38-.117Z",
    transform: "translate(6.101 12.274)",
    fill: "#ecc295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M5.082,4.117l-.095.545s.293.131.392-.591a2.086,2.086,0,0,0-.635-1.756C4.366,1.991,3.034.99,2.479,1.045s-1.037.188-1.018,1.008c0,0,.159.064.256-.245s.912.478.9.98-.8,1.391-1.564.916A2.037,2.037,0,0,1,.478.676C1.507-.423,3.65-.135,4.909,1.2A4.951,4.951,0,0,1,6.368,5.512c-.3,1.314-1.641,1.016-2.119.149A1.833,1.833,0,0,1,4.11,3.714C4.388,3.351,5.082,4.117,5.082,4.117Z",
    transform: "translate(0 11.481)",
    fill: "#ecc295"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.2385d1bfc82e422cb3a9c208fe61e048.svg";
export { ForwardRef as ReactComponent };